@if (success()) {
  <app-window class="register-confirmation">
    <span title>{{ 'features.createAccountConfirmation.title' | translate }}</span>
    <div body>
      <div class="register-confirmation-form">
        {{ 'features.createAccountConfirmation.success' | translate }}
        <a routerLink="/user/login">{{ 'features.createAccountConfirmation.login' | translate }}</a>
      </div>
    </div>
  </app-window>
} @else {
  <app-window class="register-confirmation">
    <span title>{{ 'features.createAccountConfirmation.title' | translate }}</span>
    <div body>
      <div class="register-confirmation-form">
        {{ 'features.createAccountConfirmation.error' | translate }}
        <a routerLink="/user/login">{{ 'features.createAccountConfirmation.login' | translate }}</a>
      </div>
    </div>
  </app-window>
}
